import React, { useCallback, useState } from 'react';
import { observer, inject } from 'mobx-react';

import { Box, Flex, EmptyState } from 'core/components';
import TabbedChart from 'app/components/tabbedChart/TabbedChart';
import Page from 'app/components/page/Page';
import AggregateViewHeader from 'app/views/core/aggregate/AggregateViewHeader';
import parentLinks from 'app/views/core/NetworkExplorerParentLink';
import { CloudsTable } from 'app/views/core/CloudsTable';

const _Clouds = ({ $devices }) => {
  const [aggregateType, setAggregateType] = useState('p95th_bits_per_sec');
  const [filters, setFilters] = useState([]);
  const [lookbackSeconds, setLookbackSeconds] = useState(86400);

  const handleFiltersApply = useCallback((newFilters) => {
    setFilters([...newFilters]);
  }, []);

  const handleLookbackChange = useCallback((newLookbackSeconds) => {
    setLookbackSeconds(newLookbackSeconds);
  }, []);

  const handleAggregationChange = useCallback((newAggregateType) => {
    setAggregateType(newAggregateType);
  }, []);

  const { hasGCEDevice, hasAzureDevice, hasAWSDevice, hasOCIDevice } = $devices;
  const devices = [
    ...(hasGCEDevice ? ['gcp_subnet'] : []),
    ...(hasAzureDevice ? ['azure_subnet'] : []),
    ...(hasAWSDevice ? ['aws_subnet'] : []),
    ...(hasOCIDevice ? ['oci_subnet'] : [])
  ];

  const queryOverrides = {
    all_devices: false,
    device_types: devices,
    aggregateTypes: [aggregateType],
    lookback_seconds: lookbackSeconds,
    topx: 350,
    depth: 350
  };

  return (
    <Page title="Clouds" parentLinks={parentLinks} scrolls showExport>
      {devices.length === 0 && (
        <Flex flex="1 1 auto" flexDirection="column" justifyContent="center" alignItems="center">
          <EmptyState
            title="No Results"
            description="No cloud devices are present in the network. Please add cloud devices to the network."
          />
        </Flex>
      )}

      {devices.length > 0 && (
        <>
          <AggregateViewHeader
            title="Clouds"
            aggregateType={aggregateType}
            filters={filters}
            lookbackSeconds={lookbackSeconds}
            onFiltersChange={handleFiltersApply}
            onAggregateChange={handleAggregationChange}
            onMetricsChange={handleAggregationChange}
            onTimeRangeChange={handleLookbackChange}
          />
          <Box mb={2}>
            <TabbedChart
              overrides={queryOverrides}
              simpleFilters={filters}
              metrics={{
                Internal: 'i_device_subtype',
                Inbound: 'i_device_subtype',
                Outbound: 'i_device_subtype',
                Through: 'i_device_subtype'
              }}
              queryName="cloudInboundOutboundQuery"
              showNativeLegend
            />
          </Box>

          <CloudsTable
            lookbackSeconds={lookbackSeconds}
            aggregateType={aggregateType}
            filters={filters}
            device_types={devices}
          />
        </>
      )}
    </Page>
  );
};

const Clouds = inject('$devices')(observer(_Clouds));

export default Clouds;
